import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../Navbar';
import Footer from './Footer';
import { GlobalBrandStyles, ScrollProgress, ScrollToTopButton } from '../shared/ui';
import { OrganizationSchema } from './StructuredData';

// Bei jedem Routenwechsel nach oben scrollen
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

declare global {
  interface Window {
    va?: (event: 'pageview', properties: { path: string }) => void;
  }
}

/**
 * Meldet Seitenaufrufe bei Router-Navigation an Vercel Web Analytics.
 *
 * Das in public/index.html eingebundene Script zaehlt nur den ersten Aufruf;
 * die weitere Navigation dieser Single-Page-App bekommt es nicht mit. Ohne
 * diesen Nachtrag wuerden ausschliesslich Einstiegsseiten in der Statistik
 * auftauchen. Der erste Durchlauf wird uebersprungen, sonst waere der
 * Einstieg doppelt gezaehlt.
 */
const AnalyticsPageviews: React.FC = () => {
  const { pathname } = useLocation();
  const initialRender = React.useRef(true);

  React.useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      return;
    }
    window.va?.('pageview', { path: pathname });
  }, [pathname]);

  return null;
};

const Layout: React.FC = () => (
  <>
    <GlobalBrandStyles />
    <OrganizationSchema />
    <ScrollProgress />
    <ScrollToTop />
    <AnalyticsPageviews />
    <div>
      <Navbar />
      <Outlet />
      <Footer />
    </div>
    <ScrollToTopButton />
  </>
);

export default Layout;
